import { z } from "zod";
import { LookupQuerySchema, OutsourcePayeeTypeSchema } from "./common";

export const OUTSOURCE_CATEGORY_SEED_SLUGS = [
  "kol",
  "photography",
  "videography",
  "live_stream",
  "production_house",
  "mc_host",
  "styling",
  "other",
] as const;

export const OutsourceCategorySlugSchema = z
  .string()
  .trim()
  .min(1, "ຕ້ອງປ້ອນ slug")
  .max(64)
  .regex(/^[a-z0-9_]+$/, "slug ຕ້ອງເປັນ a-z, 0-9, _");

export const OutsourceCategorySchema = z.object({
  id: z.string(),
  slug: z.string(),
  name: z.string(),
  nameLo: z.string(),
  defaultPayeeType: OutsourcePayeeTypeSchema.nullable(),
  sortOrder: z.number().int(),
  isActive: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type OutsourceCategoryDTO = z.infer<typeof OutsourceCategorySchema>;

export const CreateOutsourceCategorySchema = z.object({
  slug: OutsourceCategorySlugSchema,
  name: z.string().min(1, "ຕ້ອງປ້ອນຊື່ (EN)"),
  nameLo: z.string().min(1, "ຕ້ອງປ້ອນຊື່ (ລາວ)"),
  defaultPayeeType: OutsourcePayeeTypeSchema.nullable().optional(),
  sortOrder: z.number().int().default(0),
  isActive: z.boolean().default(true),
});
export type CreateOutsourceCategoryDTO = z.infer<
  typeof CreateOutsourceCategorySchema
>;

export const UpdateOutsourceCategorySchema =
  CreateOutsourceCategorySchema.partial();
export type UpdateOutsourceCategoryDTO = z.infer<
  typeof UpdateOutsourceCategorySchema
>;

export const OutsourceCategoryLookupItemSchema = z.object({
  id: z.string(),
  slug: z.string(),
  name: z.string(),
  nameLo: z.string(),
  defaultPayeeType: OutsourcePayeeTypeSchema.nullable(),
});
export type OutsourceCategoryLookupItemDTO = z.infer<
  typeof OutsourceCategoryLookupItemSchema
>;

export { LookupQuerySchema as OutsourceCategoryLookupQuerySchema };
export type OutsourceCategoryLookupQueryDTO = z.infer<typeof LookupQuerySchema>;
